import axiosInstance from '../../lib/axios';
import { cancellableGet } from '../../lib/cancellableGet';

export const fetchTeamMembers = async () => {
  const response = await axiosInstance.get('/admin/team/');
  return response.data;
};

export const fetchMemberProfile = async (id, signal) => {
  const response = await axiosInstance.get(`/admin/team/${id}/profile/`, { signal });
  return response.data;
};

export const patchMemberProfile = async (id, fields) => {
  const response = await axiosInstance.patch(`/admin/team/${id}/profile/`, fields);
  return response.data;
};

export const inviteTeamMember = async ({ name, email, phone_number, roles }) => {
  const response = await axiosInstance.post('/admin/team/', {
    name: name || null,
    email: email || null,
    phone_number: phone_number || null,
    roles,
  });
  return response.data;
};

export const updateTeamMember = async (id, patch) => {
  const response = await axiosInstance.patch(`/admin/team/${id}/`, patch);
  return response.data;
};

export const deleteTeamMember = async (id) => {
  const response = await axiosInstance.delete(`/admin/team/${id}/`);
  return response.data;
};

// One call for one or many members; the server reports updated / blocked / missing per id.
export const bulkTeamMembers = async ({ member_ids, op, roles, active }) => {
  const response = await axiosInstance.post('/admin/team/bulk/', {
    member_ids,
    op,
    roles,
    active,
  });
  return response.data;
};

export const resetTeamMemberMfa = async (id) => {
  const response = await axiosInstance.post(`/admin/team/${id}/mfa/reset/`);
  return response.data;
};

// Members plus roster for a range (default: this UTC Mon-Sun week); counts `total` + `count`.
export const fetchTeamShifts = ({ roles, dateFrom, dateTo, page = 1, limit = 50 } = {}) => {
  const params = { page, limit };
  if (roles) params.roles = roles;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  return cancellableGet('/admin/team/shifts/', { params });
};

// All-or-nothing: any existing date refuses the whole call (409 shift_exists); PUT to change.
// Entries: { shift_date, start_time, end_time } in UTC, or { shift_date, is_off: true }.
export const createTeamShifts = async (memberId, shifts) => {
  const response = await axiosInstance.post(`/admin/team/${memberId}/shifts/`, { shifts });
  return response.data;
};

// The mirror: a date with no shift refuses the whole call, so PUT never quietly adds one.
export const updateTeamShifts = async (memberId, shifts) => {
  const response = await axiosInstance.put(`/admin/team/${memberId}/shifts/`, { shifts });
  return response.data;
};

// Clears every rostered date in the range. Cleared dates read back as not rostered.
export const clearTeamShifts = async (memberId, { dateFrom, dateTo }) => {
  await axiosInstance.delete(`/admin/team/${memberId}/shifts/`, {
    params: { date_from: dateFrom, date_to: dateTo },
  });
  return memberId;
};
